import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { LocaleService } from '@shared/services/locale.service';

@Component({
	selector: 'app-help',
	templateUrl: './help.component.html',
	styleUrls: ['./help.component.scss'],
})
export class HelpComponent implements OnInit {
	constructor(private title: Title, public locale: LocaleService) {}

	ngOnInit(): void {
		this.title.setTitle(this.locale.translations['help']['n126'] + ' | ' + this.locale.translations['header']['n0']);
	}
}
